import React, { useState, useEffect, Fragment, useContext } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import HistoryIcon from "@material-ui/icons/History";
import EditIcon from "@material-ui/icons/Edit";
import PublishIcon from "@material-ui/icons/Publish";
import ClearIcon from "@material-ui/icons/Clear";
import { FilterList } from "@material-ui/icons";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
// import SelectedVariations from "./SelectedVariations";
import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Icon,
  Switch,
  Typography,
  Select,
  Menu,
  MenuItem,
  Box,
} from "@material-ui/core";
// import ScenarioGroupingFlow from "./ScenarioGroupingFlow";
import Modal from "../../cm_shared/cm_global_modal";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";
import ScenarioGroupInstanceDetails from "../ScenarioGroupInstanceDetails";
import ScenarioGroupingFlow from "./../ScenarioGroupingFlow";
import TopologyCart from "../TopologyCart";
import { Tooltip } from "@material-ui/core";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import ConditionalFilter from "../../cm_shared/CMConditionalFilter";
import CMUpload from "../CMUpload";
import ScenarioVersions from "../ScenarioVersions";
import SelectedScenarioGroupDetails from "../SelectedScenarioGroupDetails";
import HelpIcon from "@material-ui/icons/Help";
import HelperComponent from "../../cm_shared/Reporting/CustomHelper/index";
import GroupIdRangeSelection from "./GroupIdRange";
import LatestCountForGrouping from "./LatestCountForGrouping"
import styled from "styled-components";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import { LoadingContext } from "../../../../context/spinnerContext";

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      minHeight: "unset"
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};
const loadingStyles = makeStyles({
  fctwToggle: {
    border: '1px solid rgba(0,0,0,.2)',
    height: '56px',
    width: '135px',
    borderRadius: '5px',
    padding: '0.5rem'
  }
});
const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 380px)
  }
`;

const ScenarioGroupListing = () => {
  const classes = loadingStyles();
  const [options, setOptions] = useState([]);
  const [scenarioGroups, setScenarioGroups] = useState([]);
  // const [loading, setLoading] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [fctwSelected, setFctwSelected] = useState(false);
  const [advancedSearchString, setAdvancedSearchString] = useState("");
  const [savedFilters, setSavedFilters] = useState([]);
  const [columns, setColumns] = useState(initialColumns);
  const [page, setPage] = useState(0);
  const [selectAllOpts, setSelectAllOpts] = useState(null);
  const [total, setTotal] = useState(0);
  const rowsPerPageSessionBased = [10, 20, 50, 100, 500];
  const [modalForRange, setModalForRange] = useState(false);
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [selectValue, setSelectValue] = useState("");
  const [modelOptions, setModelOptions] = useState([]);
  const [currentFilters, setCurrentFilters] = useState({});
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteScenarioUuid, setDeleteScenarioUuid] = useState(null);
  const { setIsLoading, isLoading:loading } = useContext(LoadingContext);

  const handleClose = () => {
    setIsOpen(false);
  };

  const fetchFilterOptions = async () => {
    const response = await axios.post(
      "/cm/close_loop/fetch_filters_for_page_v2",
      // "/cm/open_loop/fetch_filters_for_page_v2",
      {
        page_filter: "close_cm_loop_scenario_group",
      }
    );

    let filtersToSet = {}
    const filtersReceived = response.data[0] ? response.data[0].filters : {}
    Object.entries(filtersReceived).map((filterDetails) => {
      if (filterDetails[1].visible === true) {
        filtersToSet[filterDetails[0]] = filterDetails[1];
      }
    });

    setOptions(filtersToSet);
  };

  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleResetForm = () => {
    setAdvancedSearchString("");
    setSavedFilters([]);
    fetchScenarioGroups({});
    // fetchScenarioCollectionNew({});
    setColumns(initialColumns);
    setPage(0);
    setCurrentFilters({});
  };

  const handleEditScenarioInstanceDetails = () => {
    setIsOpen(false);
    fetchScenarioGroups(
      JSON.stringify([{ model_name: [selectValue] }, currentFilters])
    );
  };

  const handleModalClose = () => {
    setIsOpen(false);
  };

  const handleFctwToggle = (event) => {
    console.log('event.target.checked', event.target.checked);
    setFctwSelected(event.target.checked);
    setCartItems([]);
    setPage(0);
  }

  const handleAdvancedFilterSearch = (value, savedFiltersPassed) => {
    setAdvancedSearchString(value);
    setSavedFilters(savedFiltersPassed);
    setIsOpen(false);
    const filters = JSON.stringify([{ model_name: [selectValue] }, ...value]);
    setCurrentFilters(filters);
    fetchScenarioGroups(filters);
  };

  const initialColumns = [
    {
      name: "Scenario Group Name",
      selector: "scenario_group_name",
      sortable: true,
      grow: 2,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>{row.scenario_group_name}</div>
      ),
    },
    {
      name: "Group ID",
      selector: "scenario_group_id",
      sortable: true,
      cell: (row) => (
        <div style={{ alignContent: "center" }}>{row.scenario_group_id}</div>
      ),
    },
    {
      name: "Updated At",
      selector: "scenario_group_updated_at",
      sortable: true,
      cell: (row) => (
        <span>{row.scenario_group_updated_at}</span>
      )
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: false,
      cell: (row) => {
        const isInCart = cartItems.some(
          (item) => item.scenario_group_name === row.scenario_group_name
        );
        return (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Tooltip
              placement="top"
              title={<h6>{isInCart ? "Remove from cart" : "Add to cart"}</h6>}
            >
              <IconButton
                aria-label={isInCart ? "remove" : "add"}
                style={{marginLeft: '-1rem'}}
                onClick={() =>
                  isInCart
                    ? handleRemoveFromCart(row.scenario_group_name)
                    : handleAddToCart(row)
                }
              >
                {isInCart ? <RemoveCircleIcon /> : <AddIcon />}
              </IconButton>
            </Tooltip>
            <Tooltip placement="top" title={<h6>Delete</h6>}>
              <IconButton
                aria-label="delete"
                style={{display: 'none'}}
                onClick={() => {
                  setConfirmDeleteOpen(true);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <IconButton
              aria-label="download"
              // onClick={() => handleViewInstanceDetails(row)}
              onClick={() =>
                handleModal(
                  <ScenarioGroupInstanceDetails
                    data={row}
                    handleClose={handleModalClose}
                    handleEditScenarioInstanceDetails={
                      handleEditScenarioInstanceDetails
                    }
                  />
                )
              }
            >
              <EditIcon />
            </IconButton>
            {/* <IconButton
              aria-label="download"
              onClick={() => handleModal(<ScenarioVersions data={row} />)}
            >
              <HistoryIcon />
            </IconButton> */}
          </div>
        );
      },
    },
  ];

  const fetchScenarioGroups = async (searchOptions) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        "/get_cm_scenario_groups_close_loop_instance_details?page=1",
        {
          page_number: page + 1,
          page_size: eventsPerPage,
          page_number_record: page + 1,
          page_size_record: eventsPerPage,
          searchOptions,
          fctw: fctwSelected
        }
        // { total_variation_count: 0, data: [], is_deleted: false, searchOptions }
      );
      setScenarioGroups(response.data.data);
      setTotal(response.data.total_records);
    } catch(err) {
      console.error('err', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddToCart = (scenario) => {
    setCartItems((prevCart) => [...prevCart, scenario]);
  };

  const handleRemoveFromCart = (scenario_group_name) => {
    setCartItems((prevCart) =>
      prevCart.filter(
        (item) => item.scenario_group_name !== scenario_group_name
      )
    );
  };
  const handleDownload = async (scenarioToDownload) => {
    const fileToDownload = await axios.post(
      "cm_close_loop/cm_scenario_download",
      {
        scenario_uuid: scenarioToDownload,
      },
      { responseType: "blob" }
    );
    // window.open(fileToDownload, "_self");

    const url = window.URL.createObjectURL(new Blob([fileToDownload.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      fileToDownload.headers["content-disposition"].split("filename=")[1]
    );
    document.body.appendChild(link);
    link.click();
  };

  const fetchSelectOptions = async () => {
    const response = await axios.post(
      "/cm/close_loop/fetch-carmaker_model_record_V2"
    );
    setModelOptions(response.data);
    if (response.data && response.data.length > 0) {
      const defaultSelectValue = response.data.filter(item => item.value === 'Generic')[0].value;
      setSelectValue(defaultSelectValue);
      // setCurrentFilters(JSON.stringify([{ model_name: [defaultSelectValue] }]));
    }
  };

  const handleSelectChange = (event) => {
    const newSelectValue = event.target.value;
    setSelectValue(newSelectValue);
    // const newSearchOptions = JSON.stringify([{ model_name: [newSelectValue] }]);
    setPage(0);
    setCartItems([]);
    // setAllSelected(false);
    // setCurrentFilters(newSearchOptions);
    // fetchScenarioCollectionNew(newSearchOptions);
    // fetchScenarioGroups(newSearchOptions);
  };

  const getCountOrRangeForSelectAll = async (rangeOrCount) => {
    const payload =  {
      searchOptions: JSON.stringify([{ model_name: [selectValue] }, currentFilters]),
      fctw: fctwSelected,
    }
    if (typeof rangeOrCount === 'string') payload.count = parseInt(rangeOrCount);
    else payload.group_id_range = rangeOrCount;
    console.log('payload', payload);
    const response = await axios.post(
      "/cm/close_loop/select_all_for_close_loop_scenario_group", payload);
    console.log('response', response.data.data);
    const arrItems = [...cartItems, ...response.data.data];
    const uniqueItems = Array.from(
      new Map(arrItems.map(item => [item.scenario_group_name, item])).values()
    );
    setCartItems(uniqueItems);
    handleModalClose();
    setModalForRange(false);
    response.data.data && response.data.data.length !== 0 && handleModal(
      <TopologyCart
        fctw={fctwSelected}
        cartItems={uniqueItems}
        clearCart={() => {
          setCartItems([]);
          handleModalClose();
        }}
        onRemoveFromCart={handleRemoveFromCart}
        handleClose={handleModalClose}
      />
    )
  }
  const handleViewInstanceDetails = () => {};
  useEffect(() => {
    fetchSelectOptions();
    // fetchFilterOptions();
  }, []);

  useEffect(() => {
    setColumns(initialColumns);
    selectValue &&
      fetchScenarioGroups(
        JSON.stringify([{ model_name: [selectValue] }, currentFilters])
      );
  }, [eventsPerPage, page, selectValue, fctwSelected]);

  useEffect(() => {
    setColumns(initialColumns);
  }, [cartItems]);

  const handleModal = (content, forRange=false) => {
    setModalContent(content);
    setIsOpen(true);
    forRange && setModalForRange(true);
  };

  // api for delete will come here - this is coming from Sql so as of now we are not integrating this.This will be for future .
  const handleDelete = () => {
    console.log("api comes here");
  }

  return (
    <div
      style={{
        padding: "0.6rem",
        position: "relative",
        background: "white",
        margin: "10px",
        borderRadius: "10px",
        height: "calc(100% - 120px)"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          padding: "5px",
          width: "100%",
        }}
      >
        <Typography variant="h5">
          <Link to="/welcome">Closed Loop </Link> {">"} Scenario Groups
        </Typography>
        <div>
        <Button
            variant="contained"
            style={{
              backgroundColor: "#622AD8",
              color: "#ffffff",
            }}
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={(e) => setSelectAllOpts(e.currentTarget)}
          >
            Select All
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={selectAllOpts}
            keepMounted
            open={Boolean(selectAllOpts)}
            onClose={() => setSelectAllOpts(null)}
          >
            <MenuItem
              onClick={() => {
                setSelectAllOpts(null)
                handleModal(
                  <LatestCountForGrouping 
                  closeRangeDailog={() => {
                    setModalForRange(false);
                    handleModalClose();
                  }}
                  getGroups={getCountOrRangeForSelectAll}
                />,
                true
                );
              }}
            >
              <Typography style={{display:"inline"}}>
                  Latest count
              </Typography>
            </MenuItem>
            <MenuItem
              onClick={() => {
                setSelectAllOpts(null)
                handleModal(
                  <GroupIdRangeSelection 
                    closeRangeDailog={() => {
                      setModalForRange(false);
                      handleModalClose();
                    }}
                    getGroups={getCountOrRangeForSelectAll}
                  />,
                  true
                );
              }}
            >
              <Typography style={{display:"inline"}}>
                  Group Id range
              </Typography>
            </MenuItem>
          </Menu>
          <IconButton
            color="inherit"
            onClick={() =>
              handleModal(
                <TopologyCart
                  fctw={fctwSelected}
                  cartItems={cartItems}
                  clearCart={() => {
                    setCartItems([]);
                    handleModalClose();
                  }}
                  onRemoveFromCart={handleRemoveFromCart}
                  handleClose={handleModalClose}
                />
              )
            }
          >
            <Badge max={5000} badgeContent={cartItems && cartItems.length} color="secondary">
              <NoteAddIcon />
            </Badge>
          </IconButton>
          <Tooltip placement="top" title={<h6>Help</h6>}>
            <IconButton
              color="inherit"
              onClick={() =>
                handleModal(
                  <HelperComponent
                    closeHandler={setIsOpen}
                    contentController={[
                      {
                        value: "tutorialVideo",
                        label: "Tutorial",
                        tutorials: [{
                        videoURL: "/video/closeloopscenario.mp4",
                        text: "In this tutorial, we will have a walkthrough on how to use the close loop scenario group listing",
                        title: "Close loop | Scenario Grouping"}]
                      },
                    ]}
                    defaultSelector="tutorialVideo"
                  />,
                )
              }
            >
              <Badge max={5000} color="secondary">
                <HelpIcon />
              </Badge>
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <Divider />
      <Box style={{display:"none"}}>
       {/* Filter Button */}
       {Object.keys(options).length ?
       <Fragment>
              <Button
                onClick={() =>
                  handleModal(
                    <ConditionalFilter
                      handleClose={handleClose}
                      options={options}
                      handleAdvancedFilterSearch={handleAdvancedFilterSearch}
                      preSelectedFilters={savedFilters}
                    />
                  )
                }
                variant="contained"
                style={{ backgroundColor: "#622ad8", color: "white" }}
                startIcon={<FilterList />}
              >
                Filter
              </Button> 
                  <Button
                  onClick={handleResetForm}
                  variant="outlined"
                  startIcon={<ClearIcon />}
                >
                  Clear
                </Button>
              </Fragment>
              : null}

               {/* Clear */}
           
      </Box>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={modalForRange ? "sm" : "lg"}
        heightVal={modalForRange ? '250px' : '500px'}
      />

      <Grid
        container
        spacing={3}
        style={{
          marginTop: "5px",
          marginBottom: "5px",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        {/* <Grid item>
          <Button
            onClick={
              () => handleModal()
              // <ConditionalFilter
              //   options={options}
              //   handleAdvancedFilterSearch={handleAdvancedFilterSearch}
              //   preSelectedFilters={savedFilters}
              // />
            }
            variant="contained"
            style={{ backgroundColor: "#622ad8", color: "white" }}
            startIcon={<FilterList />}
            disabled={true}
          >
            Filter
          </Button>

          <Button
            onClick={handleResetForm}
            variant="outlined"
            startIcon={<ClearIcon />}
            color=""
          >
            Clear
          </Button>*/}
        </Grid> 
        <Grid
        container
        spacing={3}
        style={{
          marginTop: "5px",
          marginBottom: "5px",
          justifyContent: "space-between",
        }}
        >
          <Grid item >
          {/* <FormControl
            variant="outlined"
            style={{ minWidth: 200, marginBottom: "10px" }}
          >
            <Select value={selectValue} onChange={handleSelectChange}>
              {modelOptions.map((option) => (
                <MenuItem key={option._id} value={option.value}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <FormControlLabel
            className={classes.fctwToggle}
            value="start"
            control={
              <Switch
                checked={fctwSelected}
                onChange={handleFctwToggle}
                color="primary"
                name="fctw"
              />
            }
            label="FCTW"
            labelPlacement="start"
          />
          </Grid>
          <Grid item>
          <CustomPagination
              total={total}
              rowsPerPageOptions={rowsPerPageSessionBased}
              eventsPerPage={eventsPerPage}
              page={page}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              onPageChange={(event, newPage) => setPage(newPage)}
            />
          </Grid>
        </Grid>
        {loading === false && columns && columns.length > 0 ? (
          <StyledDataTable
            columns={columns}
            data={scenarioGroups}
            customStyles={customStyles}
            expandableRowsComponent={<SelectedScenarioGroupDetails />}
            expandableRows
          ></StyledDataTable>
        ) : null}
        <CMDeleteModal
        open={confirmDeleteOpen}
        message="Are you sure you want to delete this scenario?"
        onCancel={() => setConfirmDeleteOpen(false)}
        onConfirm={() => handleDelete()}
      />
      </div>
  );
};

export default ScenarioGroupListing;
